import React from 'react';
import { styles } from './item-list-styles';

interface Props {
  ejListSize: number;
  pageSize: number;
  isCustomerDisplay?: boolean;
  isTenderEligibleItems?: boolean;
  pinnedAndTender?: boolean;
  items?: boolean;
  pinnedItems?: boolean;
  tenderEligibleItems?: boolean;
  children: JSX.Element;
  scrollRef?: (instance: HTMLDivElement | null) => void;
}

const ItemListContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    ejListSize,
    pageSize,
    isCustomerDisplay,
    items,
    isTenderEligibleItems,
    pinnedAndTender,
    pinnedItems,
    tenderEligibleItems,
    scrollRef,
    children,
  } = props;
  const classes = styles({ ejListSize, pageSize });

  const itemsClass = items ? (pinnedAndTender ? classes.bottomItemsPinned : '') : '';
  const tenderEligibleClass = !items
    ? tenderEligibleItems
      ? classes.tenderEligibilityListContainer
      : ''
    : '';
  const pinnedItemsClass = !items
    ? pinnedItems
      ? isTenderEligibleItems
        ? classes.pinnedItemListContainer
        : ''
      : ''
    : '';

  return (
    <div
      className={` ${
        isCustomerDisplay ? classes.itemListContainerCustomer : classes.itemListContainer
      } ${itemsClass}
        ${tenderEligibleClass}
      ${pinnedItemsClass}
       verticalScroll fullWidth`}
      ref={scrollRef}
      data-testid='item-list-container'
    >
      {children}
    </div>
  );
};

export default ItemListContainer;
